export const hideOverflow = (hide = true) => {

    if (hide) {
        document.body.classList.add('hideOverflow');
    } else {
        document.body.classList.remove('hideOverflow');
    }

};
